// @mui 
import { Paper, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { styled } from "@mui/material/styles";
import { checkRouteAccess } from "../../utils/common";
// @mui icons
import { useNavigate } from "react-router-dom";
import Iconify from "../iconify";

const CustomMenuSection = styled('div')(() => ({
    flexDirection: "column",
    position: "fixed",
    left: 65,
    minWidth: "72px",
    zIndex: 100,
    color: "#637381"
}))

const MenuPaper = styled(Paper)(({ }) => ({
    width: 170,
    height: 50,
    textAlign: 'center',
    ml: '12px',
    mt: '-10px',
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    // '&:before': {
    //     content: '""',
    //     display: 'block',
    //     position: 'absolute',
    //     top: 32,
    //     right: 0,
    //     left: -5,
    //     width: 10,
    //     height: 10,
    //     backgroundColor: '#fff',
    //     transform: 'translateY(-50%) rotate(45deg)',
    //     zIndex: 0,
    // },
}));

const WhatsappSideBarHoverMenu = ({ custombox }) => {
    const navigate = useNavigate()

    return (
        <CustomMenuSection sx={{
            display: custombox ? "flex" : "none",
        }}>
            <MenuPaper elevation={20}>
                <List sx={{
                    marginTop: "5px",
                    padding: "0px",
                }}>
                  {checkRouteAccess("/whatsapp_plans") &&  <ListItem disablePadding sx={{
                        margin: "0px"
                    }}>
                        <ListItemButton onClick={() => navigate("/whatsapp_plans")}>
                            <ListItemIcon sx={{
                                // minWidth: "34px",
                                color: "grey.600",
                            }}>
                                <Iconify icon="mdi:tag-outline" />  

                            </ListItemIcon>
                            <ListItemText primary="Plans" sx={{ lineHeight: 1, margin: 0, color: "grey.600", }} />
                        </ListItemButton>
                    </ListItem>}

                  
                </List>
            </MenuPaper>
        </CustomMenuSection>

    )
}
export default WhatsappSideBarHoverMenu;